import { render } from "./PptEditor.vue?vue&type=template&id=03ef4e56"
import script from "./PptEditor.vue?vue&type=script&lang=js"
export * from "./PptEditor.vue?vue&type=script&lang=js"

import "./PptEditor.vue?vue&type=style&index=0&id=03ef4e56&lang=css"
script.render = render

export default script